import React, { useRef, useState, useEffect } from 'react'
import LayoutTitle from '../CanvasComponents/LayoutsList/LayoutTitle'
import LayoutVideoDesc from '../CanvasComponents/LayoutsList/LayoutVideoDesc'
import LayoutQA from '../CanvasComponents/LayoutsList/LayoutQA'
import LayoutQ_2_A from '../CanvasComponents/LayoutsList/LayoutQ_2_A'
import LayoutHeadDesc from '../CanvasComponents/LayoutsList/LayoutHeadDesc'
import LayoutImageHeading from '../CanvasComponents/LayoutsList/LayoutImageHeading'
import LayoutQ_3_A from '../CanvasComponents/LayoutsList/LayoutQ_3_A'
import LayoutImageAssmnt from '../CanvasComponents/LayoutsList/LayoutImageAssmnt'
import { SequenceAneme } from '../UIUtilsFiles/SequenceAnime'

function SmartCanvasTemplates(props) {
  const {
    isPractice,
    Completed,
    isActive,
    TemplateSettings,
    currentThemeData,
    isFollowTheFlow,
    InkJson,
    strokeColor,
    strokeReplayStarted,
    sketchType,
    strokeWidth,
    currentSpeed,
    studentWorkData,
    isWorkAvailable,
    displayComponents,
    priorityActive,
    isAudioPlaying,
    isMinimize,
    isReplaying,
    isPageChanged
  } = props
  const {
    handleControlsList,
    getCurrentRectangleData,
    getStrokeReplayFinished,
    onWorkFetched,
    onToastTrigger,
    onVideoControlChange,
    onPriorityChange,
    handleFeedbackMessage,
    getReplyStatus,
    handleSelectionStatus
  } = props
  let speechAI = new SpeechSynthesisUtterance()
  const { InputRows, ReplayRectangles, minutes, seconds } = props

  //Student data variables
  const [controlsList, setControlsList] = useState([])

  useEffect(() => {
    if (displayComponents) {
      if (isWorkAvailable) {
        //load component data
        if (studentWorkData.listControls.length > 0) {
          setControlsList(studentWorkData.listControls)
        }
        onWorkFetched()
      }
    }
  }, [displayComponents, isWorkAvailable])

  useEffect(() => {
    handleControlsList(controlsList)
  }, [controlsList])

  //handled embedded control data
  function handleComponentValueChange(
    ctlID,
    ctlValue,
    ctlScore,
    ctlTotalScore,
    ctlSortedArray
  ) {
    let controlListCopy = [...controlsList]
    const presentIndex = controlListCopy.findIndex(
      (item) => item.CtlId === ctlID
    )

    if (presentIndex >= 0) {
      controlListCopy[presentIndex] = {
        CtlId: ctlID,
        CtlValue: {
          Answer: ctlValue,
          Value: ctlScore
        },
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray,
        elapsedTime: minutes + ':' + seconds
      }
    } else {
      controlListCopy.push({
        CtlId: ctlID,
        CtlValue: {
          Answer: ctlValue,
          Value: ctlScore
        },
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray,
        elapsedTime: minutes + ':' + seconds
      })
    }
    // console.log('controlListCopy', controlListCopy)
    setControlsList(controlListCopy)
  }

  return (
    <div
      className='template-main-cont'
      style={{
        backgroundImage:
          TemplateSettings.layoutId < 4
            ? currentThemeData && `url(${currentThemeData.themeImage})`
            : 'unset',
        backgroundColor:
          TemplateSettings.layoutId === 1
            ? 'unset'
            : currentThemeData.themeColors.background
      }}
    >
      {TemplateSettings.layoutId === 1 ? (
        <LayoutTitle
          themeName={TemplateSettings.themeName}
          layoutData={InputRows}
          layoutType={TemplateSettings.layoutType}
          themeProperties={currentThemeData}
        />
      ) : TemplateSettings.layoutId === 2 || TemplateSettings.layoutId === 3 ? (
        <LayoutHeadDesc
          themeName={TemplateSettings.themeName}
          layoutData={InputRows}
          layoutId={TemplateSettings.layoutId}
          layoutType={TemplateSettings.layoutType}
          themeProperties={currentThemeData}
        />
      ) : TemplateSettings.layoutId === 4 ? (
        <LayoutImageHeading
          themeName={TemplateSettings.themeName}
          layoutData={InputRows}
          layoutType={TemplateSettings.layoutType}
          themeProperties={currentThemeData}
        />
      ) : TemplateSettings.layoutId === 5 ? (
        <LayoutVideoDesc
          layoutData={InputRows}
          themeProperties={currentThemeData}
          onVideoControlChange={onVideoControlChange}
          isAudioPlaying={isAudioPlaying}
          isPageChanged={isPageChanged}
        />
      ) : TemplateSettings.layoutId === 6 ? (
        <LayoutQA
          isPractice={isPractice}
          Completed={Completed}
          isActive={isActive}
          layoutData={InputRows}
          themeProperties={currentThemeData}
          controlsList={controlsList}
          isFollowTheFlow={isFollowTheFlow}
          priorityActive={priorityActive}
          handleValueChange={handleComponentValueChange}
          onPriorityChange={onPriorityChange}
          handleSucAndFailFeedback={handleFeedbackMessage}
          // ReplayRectangle Data
          InkJson={InkJson}
          replayRectangles={ReplayRectangles}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          currentSpeed={currentSpeed}
          strokeReplayStarted={strokeReplayStarted}
          sketchType={sketchType}
          getStrokeReplayFinished={getStrokeReplayFinished}
          getCurrentRectangleData={getCurrentRectangleData}
          getReplyStatus={getReplyStatus}
          //Toast variables
          onToastTrigger={onToastTrigger}
          onVideoControlChange={onVideoControlChange}
          isAudioPlaying={isAudioPlaying}
          isMinimize={isMinimize}
          isReplaying={isReplaying}
          handleSelectionStatus={handleSelectionStatus}
        />
      ) : TemplateSettings.layoutId === 7 ? (
        <LayoutQ_2_A
          isPractice={isPractice}
          Completed={Completed}
          isActive={isActive}
          layoutData={InputRows}
          themeProperties={currentThemeData}
          controlsList={controlsList}
          isFollowTheFlow={isFollowTheFlow}
          priorityActive={priorityActive}
          handleValueChange={handleComponentValueChange}
          onPriorityChange={onPriorityChange}
          handleSucAndFailFeedback={handleFeedbackMessage}
          // ReplayRectangle Data
          InkJson={InkJson}
          replayRectangles={ReplayRectangles}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          currentSpeed={currentSpeed}
          strokeReplayStarted={strokeReplayStarted}
          sketchType={sketchType}
          getStrokeReplayFinished={getStrokeReplayFinished}
          getCurrentRectangleData={getCurrentRectangleData}
          getReplyStatus={getReplyStatus}
          //Toast variables
          onToastTrigger={onToastTrigger}
          onVideoControlChange={onVideoControlChange}
          isAudioPlaying={isAudioPlaying}
          isMinimize={isMinimize}
          isReplaying={isReplaying}
        />
      ) : TemplateSettings.layoutId === 8 || TemplateSettings.layoutId === 9 ? (
        <LayoutQ_3_A
          isPractice={isPractice}
          Completed={Completed}
          isActive={isActive}
          layoutData={InputRows}
          layoutId={TemplateSettings.layoutId}
          layoutType={TemplateSettings.layoutType}
          themeProperties={currentThemeData}
          controlsList={controlsList}
          isFollowTheFlow={isFollowTheFlow}
          priorityActive={priorityActive}
          handleValueChange={handleComponentValueChange}
          onPriorityChange={onPriorityChange}
          handleSucAndFailFeedback={handleFeedbackMessage}
          // ReplayRectangle Data
          InkJson={InkJson}
          replayRectangles={ReplayRectangles}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          currentSpeed={currentSpeed}
          strokeReplayStarted={strokeReplayStarted}
          sketchType={sketchType}
          getStrokeReplayFinished={getStrokeReplayFinished}
          getCurrentRectangleData={getCurrentRectangleData}
          getReplyStatus={getReplyStatus}
          //Toast variables
          onToastTrigger={onToastTrigger}
          onVideoControlChange={onVideoControlChange}
          isAudioPlaying={isAudioPlaying}
          isMinimize={isMinimize}
          isReplaying={isReplaying}
        />
      ) : TemplateSettings.layoutId === 10 ||
        TemplateSettings.layoutId === 11 ? (
        <LayoutImageAssmnt
          isPractice={isPractice}
          Completed={Completed}
          isActive={isActive}
          layoutData={InputRows}
          layoutId={TemplateSettings.layoutId}
          layoutType={TemplateSettings.layoutType}
          themeProperties={currentThemeData}
          controlsList={controlsList}
          isFollowTheFlow={isFollowTheFlow}
          priorityActive={priorityActive}
          handleValueChange={handleComponentValueChange}
          onPriorityChange={onPriorityChange}
          handleSucAndFailFeedback={handleFeedbackMessage}
          // ReplayRectangle Data
          InkJson={InkJson}
          replayRectangles={ReplayRectangles}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          currentSpeed={currentSpeed}
          strokeReplayStarted={strokeReplayStarted}
          sketchType={sketchType}
          getStrokeReplayFinished={getStrokeReplayFinished}
          getCurrentRectangleData={getCurrentRectangleData}
          getReplyStatus={getReplyStatus}
          //Toast variables
          onToastTrigger={onToastTrigger}
          onVideoControlChange={onVideoControlChange}
          isAudioPlaying={isAudioPlaying}
          isReplaying={isReplaying}
        />
      ) : (
        <div />
      )}
    </div>
  )
}
export { SmartCanvasTemplates }
